import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import determinarPaginaAtuaFechamentoCaixa from '../../actions/fechamento-caixa/determinarPaginaAtuaFechamentoCaixa'
import BotoesPaginacao from '../comum/BotoesPaginacao'

export class BotoesPaginacaoFechamentoCaixa extends Component {
  render () {
    return <BotoesPaginacao
      numeroElementos={this.props.total}
      paginaAtual={this.props.paginaAtual}
      registrosPorPagina={this.props.registrosPorPagina}
      determinarPaginaAtual={this.props.determinarPaginaAtuaFechamentoCaixa}/>
  }
}

export function mapStateToProps (state) {
  return {
    paginaAtual: state.paginaAtualFechamentoCaixa,
    total: state.fechamentosCaixa.total,
    registrosPorPagina: state.registrosPorPaginaFechamentoCaixa
  }
}

export function mapDispatchToProps (dispatch) {
  return bindActionCreators({ determinarPaginaAtuaFechamentoCaixa }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(BotoesPaginacaoFechamentoCaixa)
